var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","d":"M3 .5h18M0 .5h1M3 7.5h18M0 7.5h1M3 14.5h18M0 14.5h1"}));
}

List.defaultProps = {"fill":"none","viewBox":"0 0 21 15"};

module.exports = List;

List.default = List;
